import { cn } from '@merels/ui'
import { useSignals } from '@preact/signals-react/runtime'

import { mateListTestIds } from '../../list/MateList/mateList.testIds'

export interface OmniModeAutoControlProps {
  checked: boolean
  onChange: (checked: boolean) => void

  shouldUsePlayerColors: boolean
  currentPlayerIndex: number | null
  getPlayerColor: (playerIndex: number) => { primary: string; foreground: string } | null
}

/**
 * OmniModeAutoControl renders the "Auto" toggle used in Omni mode.
 *
 * Text may use the current player's theme color; no borders (same as PlayingAsIndicator).
 * Stops propagation so it doesn't interfere with click-to-select teams.
 */
export function OmniModeAutoControl({
  checked,
  onChange,
  shouldUsePlayerColors,
  currentPlayerIndex,
  getPlayerColor,
}: OmniModeAutoControlProps) {
  useSignals()

  const currentPlayerColor = currentPlayerIndex !== null ? getPlayerColor(currentPlayerIndex) : null

  const textStyle =
    shouldUsePlayerColors && currentPlayerColor ? { color: currentPlayerColor.foreground } : undefined

  return (
    <div className="px-2 py-2" onClick={(e) => e.stopPropagation()}>
      <label className="flex items-center gap-1.5 cursor-pointer">
        <input
          type="checkbox"
          data-testid={mateListTestIds.autoSwitchCheckbox}
          checked={checked}
          onChange={(e) => {
            e.stopPropagation()
            onChange(e.target.checked)
          }}
          className="w-4 h-4 cursor-pointer"
        />
        <span
          className={cn('text-xs font-medium', shouldUsePlayerColors ? undefined : 'text-muted')}
          style={textStyle}
        >
          Auto
        </span>
      </label>
    </div>
  )
}
